<template>
  <div>
    <el-dialog
      title="提现申请"
      :visible.sync="dialogVisible"
      width="38%"
      @close="handleClose"
    >
      <el-form ref="dataForm" :model="dataForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="22">
            <el-form-item
              prop="amount"
              label="提现金额"
              :rules="[{ required: true, message: '提现金额不能为空' }]"
            >
              <el-input
                v-model="dataForm.amount"
                placeholder="输入提现金额"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toSaveApply" :loading="btnLoading"
          >确 定</el-button
        >
        <el-button type="primary" plain :loading="btnLoading" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { withdrawApply } from "@/api/home";
export default {
  data() {
    return {
      dialogVisible: true,
      dataForm: {
        amount: "",
      },
      btnLoading: false,
    };
  },
  computed: {
    ...mapState("company", ["company"]),
  },
  methods: {
    toSaveApply() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          withdrawApply(this.dataForm)
            .then((res) => {
              this.btnLoading = false;
              if (res.code === 10000) {
                this.$message.success("申请成功");
                this.handleClose(true);
              }else if(res.code === 10001) {
                this.$message.info(res.msg);
              }
            })
            .catch((_) => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleClose(isRefresh) {
      this.$refs.dataForm.resetFields();
      this.btnLoading = false;
      this.dialogVisible = false;
      this.$emit("closeDialog", isRefresh);
    },
  },
};
</script>
